import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StudentsPerformanceReportFilterForm } from 'src/app/shared/interfaces';

import { DataWithPagination } from '../../interface';
import { StudentsPerformanceReportApi } from '../api/student-performance-api';
import { StudentsPerformanceReport } from '../model';
import { Repository } from './repository';

@Injectable({
  providedIn: 'root',
})
export class StudentsPerformanceReportRepository extends Repository {
  constructor(private studentsPerformanceReportApi: StudentsPerformanceReportApi) {
    super();
  }

  getStudentsPerformanceReport(
    filter: StudentsPerformanceReportFilterForm
  ): Observable<DataWithPagination<StudentsPerformanceReport[]>> {
    return this.studentsPerformanceReportApi.getStudentsPerformanceReport(filter);
  }
}
